var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.186,
    height: 16.646,
    viewBox: "0 0 21.186 16.646",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M15.793,26.046a1.513,1.513,0,0,0-2.14,0l-6.81,6.81a1.513,1.513,0,0,0,0,2.14l6.81,6.81a1.513,1.513,0,1,0,2.14-2.14l-4.1-4.227H26.073a1.513,1.513,0,1,0,0-3.027H11.7l4.1-4.227A1.513,1.513,0,0,0,15.793,26.046Z",
    transform: "translate(-6.4 -25.603)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.f89c9c5e7243977b8bb8430fc6ef7dd4.svg";
export { ForwardRef as ReactComponent };